import { c as _c } from "react/compiler-runtime";
// Third Party
import { filter, findIndex } from 'lodash';
import * as React from 'react';

// Utils
import { Feature, useSearch } from '@contexts/search-context';
import { PropertyType, FeatureKey } from '@gql';

// UI
import { BaseModal } from '@components/base-modal';
import { Typography } from '@components/typography';
import { Button } from '@components/button';
import { ButtonIcon } from '@components/button-icon';
import { Icon, IconNames } from '@components/icon';
import { CapacitySelector } from './features-modal/capacity-selector';
import { PropertyTypeSelection } from './features-modal/property-type-selection';
import { AmenitiesSelection } from './features-modal/amenities-selection';
import { Input } from '@components/form/input';
type Props = {
  viewAllProperties: (propertyTypes: PropertyType[], minNumberOfRooms: number, minNumberOfBathrooms: number, minPrice: number | null, maxPrice: number | null, minNumberOfBeds: number, filters: Feature[]) => void;
};
export const FeaturesModal: React.FC<Props> = t0 => {
  const $ = _c(77);
  const {
    viewAllProperties
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [PropertyType.House, PropertyType.Apartment, PropertyType.BedAndBreakfast, PropertyType.GuestHouse, PropertyType.BoutiqueHotel];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const allPropertyTypes = t1;
  const {
    activeFilters,
    allFeatures,
    deactivateFeaturesModal,
    featuresModalActive,
    handlePetFriendlyToggle,
    minNumberOfBathrooms: _minNumberOfBathrooms,
    minNumberOfRooms: _minNumberOfRooms,
    minNumberOfBeds: _minNumberOfBeds,
    minPrice: _minPrice,
    maxPrice: _maxPrice,
    propertyTypes: _propertyTypes,
    checkInDate,
    checkOutDate
  } = useSearch();
  const hasSearchDates = checkInDate !== null && checkOutDate !== null;
  const [selectedActiveFeatures, setSelectedActiveFeatures] = React.useState(activeFilters);
  let t2;
  if ($[1] !== _propertyTypes) {
    t2 = _propertyTypes || [];
    $[1] = _propertyTypes;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [propertyTypes, setPropertyTypes] = React.useState(t2);
  const [minNumberOfBeds, setMinNumberOfBeds] = React.useState(_minNumberOfBeds || 0);
  const [minNumberOfRooms, setMinNumberOfRooms] = React.useState(_minNumberOfRooms || 0);
  const [minNumberOfBathrooms, setMinNumberOfBathrooms] = React.useState(_minNumberOfBathrooms || 0);
  const [minPrice, setMinPrice] = React.useState(_minPrice);
  const [maxPrice, setMaxPrice] = React.useState(_maxPrice);
  let t3;
  let t4;
  if ($[3] !== activeFilters) {
    t3 = () => {
      setSelectedActiveFeatures(activeFilters);
    };
    t4 = [activeFilters];
    $[3] = activeFilters;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  React.useEffect(t3, t4);
  let t5;
  if ($[6] !== selectedActiveFeatures) {
    t5 = featureFilter => {
      if (featureFilter.key === FeatureKey.PetFriendly) {
        const isCurrentlyActive = selectedActiveFeatures.some(_temp);
        if (isCurrentlyActive) {
          setSelectedActiveFeatures(filter(selectedActiveFeatures, _temp2));
        } else {
          setSelectedActiveFeatures([...selectedActiveFeatures, featureFilter]);
        }
      } else {
        const i = findIndex(selectedActiveFeatures, o => o.key === featureFilter.key);
        if (i > -1) {
          setSelectedActiveFeatures(filter(selectedActiveFeatures, f_0 => f_0.key !== featureFilter.key));
        } else {
          setSelectedActiveFeatures([...selectedActiveFeatures, featureFilter]);
        }
      }
    };
    $[6] = selectedActiveFeatures;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const toggleFeatureFilter = t5;
  let t6;
  if ($[8] !== propertyTypes) {
    t6 = propertyType => {
      const i_0 = findIndex(propertyTypes, o_0 => o_0 === propertyType);
      if (i_0 > -1) {
        setPropertyTypes(filter(propertyTypes, f_1 => f_1 !== propertyType));
      } else {
        setPropertyTypes([...propertyTypes, propertyType]);
      }
    };
    $[8] = propertyTypes;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const togglePropertyType = t6;
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setPropertyTypes([]);
      setMinNumberOfRooms(0);
      setMinNumberOfBathrooms(0);
      setSelectedActiveFeatures([]);
      setMinPrice(null);
      setMaxPrice(null);
    };
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const clearSelectedFeatures = t7;
  let t8;
  if ($[11] !== deactivateFeaturesModal || $[12] !== handlePetFriendlyToggle || $[13] !== maxPrice || $[14] !== minNumberOfBathrooms || $[15] !== minNumberOfBeds || $[16] !== minNumberOfRooms || $[17] !== minPrice || $[18] !== propertyTypes || $[19] !== selectedActiveFeatures || $[20] !== viewAllProperties) {
    t8 = () => {
      const hasPetFriendlyFilter = selectedActiveFeatures.some(_temp3);
      handlePetFriendlyToggle(hasPetFriendlyFilter);
      viewAllProperties(propertyTypes, minNumberOfRooms, minNumberOfBathrooms, minPrice, maxPrice, minNumberOfBeds, selectedActiveFeatures);
      deactivateFeaturesModal();
    };
    $[11] = deactivateFeaturesModal;
    $[12] = handlePetFriendlyToggle;
    $[13] = maxPrice;
    $[14] = minNumberOfBathrooms;
    $[15] = minNumberOfBeds;
    $[16] = minNumberOfRooms;
    $[17] = minPrice;
    $[18] = propertyTypes;
    $[19] = selectedActiveFeatures;
    $[20] = viewAllProperties;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  const applyFiltersAndClose = t8;
  let t9;
  if ($[22] !== applyFiltersAndClose) {
    t9 = () => {
      applyFiltersAndClose();
    };
    $[22] = applyFiltersAndClose;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  const closeModal = t9;
  let t10;
  let t11;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="w-10 h-1" />;
    t11 = <Typography variant="title4" id="modal-headline">Filters</Typography>;
    $[24] = t10;
    $[25] = t11;
  } else {
    t10 = $[24];
    t11 = $[25];
  }
  let t12;
  if ($[26] !== closeModal) {
    t12 = <div className="w-full px-4 items-center py-3 bg-white border-b border-gray-light flex justify-between">{t10}{t11}<ButtonIcon variant="text" icon={IconNames.X} color="gray" size="md" isCircle={true} ariaLabel="Close" ariaDescribedby="close-filter-modal" onClick={closeModal} /></div>;
    $[26] = closeModal;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== hasSearchDates || $[29] !== maxPrice || $[30] !== minPrice) {
    t13 = hasSearchDates && <><div><Typography variant="title5" component="h2" className="text-primary-main">Price</Typography><Typography variant="body2" component="p" className="mt-1 text-gray-800">Nightly prices before fees and taxes</Typography><div className="mt-3 flex flex-row space-x-4"><Input className="w-[300px]" inputMode="numeric" label="Min" name="minPrice" leftContent={<Icon name={IconNames.SQUARE_DOLLAR} />} type="number" value={minPrice || ""} onChange={e => {
            const castedValue = parseFloat(e.target.value);
            setMinPrice(castedValue);
          }} /><Input className="w-[300px]" inputMode="numeric" label="Max" name="maxPrice" leftContent={<Icon name={IconNames.SQUARE_DOLLAR} />} type="number" value={maxPrice || ""} onChange={e_0 => {
            const castedValue_0 = parseFloat(e_0.target.value);
            setMaxPrice(castedValue_0);
          }} /></div></div><hr className="border-gray-light" /></>;
    $[28] = hasSearchDates;
    $[29] = maxPrice;
    $[30] = minPrice;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Typography variant="title5" component="h2" className="text-primary-main">Rooms and Bathrooms</Typography>;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = capacity => {
      setMinNumberOfRooms(capacity);
    };
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== minNumberOfRooms) {
    t16 = <CapacitySelector title="Bedrooms" capacity={minNumberOfRooms} maxCapacity={8} onCapacityUpdate={t15} />;
    $[34] = minNumberOfRooms;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = capacity_0 => {
      setMinNumberOfBathrooms(capacity_0);
    };
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== minNumberOfBathrooms) {
    t18 = <CapacitySelector title="Bathrooms" capacity={minNumberOfBathrooms} maxCapacity={8} onCapacityUpdate={t17} />;
    $[37] = minNumberOfBathrooms;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = capacity_1 => {
      setMinNumberOfBeds(capacity_1);
    };
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== minNumberOfBeds) {
    t20 = <CapacitySelector title="Beds" capacity={minNumberOfBeds} maxCapacity={8} onCapacityUpdate={t19} />;
    $[40] = minNumberOfBeds;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== t16 || $[43] !== t18 || $[44] !== t20) {
    t21 = <div>{t14}<div className="mt-3 flex flex-col whitespace-nowrap space-y-3">{t16}{t18}{t20}</div></div>;
    $[42] = t16;
    $[43] = t18;
    $[44] = t20;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  let t23;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <hr className="border-gray-light" />;
    t23 = <Typography variant="title5" component="h2" className="text-primary-main">Property Type</Typography>;
    $[46] = t22;
    $[47] = t23;
  } else {
    t22 = $[46];
    t23 = $[47];
  }
  let t24;
  if ($[48] !== propertyTypes || $[49] !== togglePropertyType) {
    t24 = <div>{t23}<PropertyTypeSelection currentPropertyTypes={propertyTypes} allPropertyTypes={allPropertyTypes} togglePropertyTypeFilter={togglePropertyType} /></div>;
    $[48] = propertyTypes;
    $[49] = togglePropertyType;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  let t25;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <hr className="border-gray-light" />;
    $[51] = t25;
  } else {
    t25 = $[51];
  }
  const t26 = selectedActiveFeatures.length > 0 ? `Amenities & Features (${selectedActiveFeatures.length})` : "Amenities & Features";
  let t27;
  if ($[52] !== t26) {
    t27 = <Typography variant="title5" component="h2" className="text-primary-main">{t26}</Typography>;
    $[52] = t26;
    $[53] = t27;
  } else {
    t27 = $[53];
  }
  let t28;
  if ($[54] !== allFeatures || $[55] !== selectedActiveFeatures || $[56] !== toggleFeatureFilter) {
    t28 = <AmenitiesSelection currentActiveFeatures={selectedActiveFeatures} allFeatures={allFeatures} toggleFeatureFilter={toggleFeatureFilter} />;
    $[54] = allFeatures;
    $[55] = selectedActiveFeatures;
    $[56] = toggleFeatureFilter;
    $[57] = t28;
  } else {
    t28 = $[57];
  }
  let t29;
  if ($[58] !== t27 || $[59] !== t28) {
    t29 = <div>{t27}{t28}</div>;
    $[58] = t27;
    $[59] = t28;
    $[60] = t29;
  } else {
    t29 = $[60];
  }
  let t30;
  if ($[61] !== t13 || $[62] !== t21 || $[63] !== t24 || $[64] !== t29) {
    t30 = <div className="px-5 py-5 sm:px-8 sm:py-8 bg-white overflow-auto"><div className="w-full space-y-6">{t13}{t21}{t22}{t24}{t25}{t29}</div></div>;
    $[61] = t13;
    $[62] = t21;
    $[63] = t24;
    $[64] = t29;
    $[65] = t30;
  } else {
    t30 = $[65];
  }
  let t31;
  if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <Button variant="text" onClick={() => {
      clearSelectedFeatures();
    }} className="underline underline-offset-2 text-primary-main">Clear all</Button>;
    $[66] = t31;
  } else {
    t31 = $[66];
  }
  let t32;
  if ($[67] !== applyFiltersAndClose) {
    t32 = <div className="flex items-center justify-between px-5 py-4 bg-white border-t border-gray-light sm:px-8">{t31}<Button variant="filled" onClick={applyFiltersAndClose}>View Properties</Button></div>;
    $[67] = applyFiltersAndClose;
    $[68] = t32;
  } else {
    t32 = $[68];
  }
  let t33;
  if ($[69] !== t12 || $[70] !== t30 || $[71] !== t32) {
    t33 = <div className="flex flex-col justify-between h-full text-primary-main">{t12}{t30}{t32}</div>;
    $[69] = t12;
    $[70] = t30;
    $[71] = t32;
    $[72] = t33;
  } else {
    t33 = $[72];
  }
  let t34;
  if ($[73] !== closeModal || $[74] !== featuresModalActive || $[75] !== t33) {
    t34 = <BaseModal isOpen={featuresModalActive} onClose={closeModal} size="xl" backdropClassName="bg-gray-main/75" showCloseButton={false} className="fixed top-24 bottom-0 sm:relative sm:top-auto sm:bottom-auto sm:h-5/6 rounded-t-lg sm:rounded-lg">{t33}</BaseModal>;
    $[73] = closeModal;
    $[74] = featuresModalActive;
    $[75] = t33;
    $[76] = t34;
  } else {
    t34 = $[76];
  }
  return t34;
};
function _temp(activeFeature) {
  return activeFeature.key === FeatureKey.PetFriendly;
}
function _temp2(f) {
  return f.key !== FeatureKey.PetFriendly;
}
function _temp3(feature) {
  return feature.key === FeatureKey.PetFriendly;
}